import { lastValueFrom } from 'rxjs';

import { API_URL, getApiUrl } from '@/utils/api';

import ApiBase from './ApiBase';

export default class CSRService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN);

  async exportAllProductAlertSinceGivenDate(date, storeId) {
    const requestUrl = `${CSRService.baseUrl}/${storeId}/productAlert?since=${date}`;
    return lastValueFrom(this.api.getTextCSV(requestUrl, { textCSV: true }));
  }
}
